import { render, staticRenderFns } from "./foodindicator.vue?vue&type=template&id=7874ecfe"
import script from "./foodindicator.vue?vue&type=script&lang=js"
export * from "./foodindicator.vue?vue&type=script&lang=js"
import style0 from "./foodindicator.vue?vue&type=style&index=0&id=7874ecfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports